import React from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";

// Components
import Loader from "../../components/common/Loader";
import Menu from "../../components/home1/Menu";
import Navbar from "../../components/home1/Navbar";
import InnerPageHeader from "../../components/innerpage/InnerPageHeader";
import Footer2 from "../../components/home2/Footer";
import Cases from "../../components/home10/Cases";

function Gallery() {
  const { t } = useTranslation();

  const breadcrumbItems = [
    { label: t("navigation.project"), href: "/innerpages/portfolio" },
    { label: t("pages.gallery.breadcrumb") }
  ];

  return (
    <>
      <Helmet>
        <title>{t("pages.gallery.title")} | Botanicheska 302</title>

        <link rel="stylesheet" href="/home1/assets/css/home_1_style.css" />
        <link rel="stylesheet" href="/home10/assets/css/home_10_style.css" />
        <link rel="stylesheet" href="/home2/assets/css/home_2_style.css" />

        <script src="/common/assets/js/common_js.js" defer></script>
        <script src="/home1/assets/js/home_1_scripts.js" defer></script>
        <script src="/home10/assets/js/home_10_scripts.js" defer></script>
      </Helmet>

      <div className="home-style1">
        <Loader />
        <Menu />
        <div className="smooth-scroll-content" id="scrollsmoother-container">
         

          <InnerPageHeader
            title={t("pages.gallery.title")}
            description={t("pages.gallery.description")}
            breadcrumbItems={breadcrumbItems}
            backgroundImage="/home1/assets/img/slider/slideimg.jpg"
          />

          <main>
            <Cases />
          </main>

          <Footer2 />
        </div>
      </div>
    </>
  );
}

export default Gallery;
